import type { PagedResultDto } from "@services/dto/pagedResultDto"
import salePolicyService from "@services/salePolicy/salePolicyService"
import { action, makeAutoObservable, observable } from "mobx"

class SalePolicyStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  @observable listSalePolicies!: any[]
  @observable listSalePoliciesForAdmin!: any[]
  @observable listSalePolicy: any
  @observable listSalePolicySpecial: any
  @observable auditLogData!: any
  constructor() {
    makeAutoObservable(this)

    this.tableData = { items: [], totalCount: 0 }
    this.detailData = {}
    this.listSalePolicies = []
    this.listSalePoliciesForAdmin = []
    this.listSalePolicySpecial = []
    this.auditLogData = []
  }

  @action
  async createOrUpdate(body: any) {
    this.isLoading = true
    try {
      if (!body.id) {
        const result = await salePolicyService.create(body)
        this.detailData = result
        this.tableData.items.push(result)
      } else {
        const result = await salePolicyService.update(body)
        this.tableData.items = this.tableData.items.map((x) => {
          if (x.id === body.id) x = result
          return x
        })
      }
    } finally {
      this.isLoading = false
    }
  }

  @action
  async newDetail() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async active(id: number, isActive) {
    await salePolicyService.active(id, isActive)
  }
  @action
  async bulkActive(id: number[]) {
    await salePolicyService.bulkActive(id)
  }
  @action
  async get(id: number) {
    const result = await salePolicyService.get(id)
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await salePolicyService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }

  @action
  async getList(params?: any) {
    this.isLoading = true
    const result = await salePolicyService
      .getList(params)
      .finally(() => (this.isLoading = false))
    this.listSalePolicies = result
  }

  @action
  async getListForAdmin(params: any) {
    this.isLoading = true
    const result = await salePolicyService
      .getListForAdmin(params)
      .finally(() => (this.isLoading = false))
    this.listSalePoliciesForAdmin = result
  }

  @action
  getSalesPolicy = async (params) => {
    this.isLoading = true
    const result = await salePolicyService
      .getSalesPolicy(params)
      .finally(() => (this.isLoading = false))
    this.listSalePolicy = result
  }
  @action
  async getAuditLog(id: any) {
    const result = await salePolicyService.getAuditLog(id)

    this.auditLogData = result
  }
  @action
  getSpecial = async (params) => {
    this.isLoading = true
    const result = await salePolicyService
      .getSpecial(params)
      .finally(() => (this.isLoading = false))
    this.listSalePolicySpecial = result
    return result
  }
}

export default SalePolicyStore
